import {
    LIST_SHARE_CERTIFICATES,
    GET_SHARE_CERTIFICATE,
    SET_SHARE_CERTIFICATE_LIEN
} from '../../index.types';

// List Share Certificates
export const listShareCertificates = (data) => ({
    type: LIST_SHARE_CERTIFICATES,
    data
});

// Get Share Certificate Detail
export const getShareCertificate = (data) => ({
    type: GET_SHARE_CERTIFICATE,
    data
});

// Mark / Release Lien
export const setShareCertificateLien = (data) => ({
    type: SET_SHARE_CERTIFICATE_LIEN,
    data
});
